<template>
  <div class="wrapper co-curicularPage" id="cocurricular">
    <section class="cocuricular-activities">
      <div class="container">
        <div class="headings">
          <h2>Co-Curricular Activities</h2>
        </div>
        <div class="desc">
          <p>
            To provide students with opportunities to explore interests, develop skills,
            and build a sense of community through structured co-curricular activities,
            clubs, and programs.
          </p>
        </div>
      </div>
    </section>

    <section class="planned-programs">
      <div class="container">
        <div class="headings">
          <h2>Planned <span class="plannedprogram-text">Programs</span></h2>
        </div>
        <div class="different-plans">
          <div class="col-lg-4 plan-box">
            <div class="head-div">
              <div class="img-div">
                <img
                  src="/assets/images/os-images/radiantMorning.png"
                  width="56"
                  height="56"
                  alt="Motivational Mondays"
                />
              </div>
              <div class="label-div">
                <h4>Radiant <br />Mornings</h4>
              </div>
            </div>
            <p>
              KOS Radiant Mornings blends mindfulness, movement, & motivation through
              daily yoga, virtual meetings, health talks, & inspiring assemblies-fueling
              bright minds for brighter futures.
            </p>
          </div>

          <div class="col-lg-4 plan-box">
            <div class="head-div">
              <div class="img-div">
                <img
                  src="/assets/images/os-images/passionProjects.png"
                  width="60"
                  height="57"
                  alt="Motivational Mondays"
                />
              </div>
              <div class="label-div">
                <h4>Passion<br />Projects</h4>
              </div>
            </div>
            <p>
              Monthly projects where students explore interests like robotics, art, or
              social causes, guided by mentors.
            </p>
          </div>

          <div class="col-lg-4 plan-box">
            <div class="head-div">
              <div class="img-div">
                <img
                  src="/assets/images/os-images/exchangeProgram.png"
                  width="60"
                  height="57"
                  alt="Motivational Mondays"
                />
              </div>
              <div class="label-div">
                <h4>Global Learning<br />Exchange Program</h4>
              </div>
            </div>
            <p>
              Collaborative projects with international students, focusing on
              cross-cultural learning.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="list-of">
      <div class="container">
        <div class="headings">
          <h2>List of Planned <span class="plannedprogram-text">Activities</span></h2>
        </div>

        <div class="activities-div">
          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof1.png"
                width="56"
                height="56"
                alt="Motivational Mondays"
              />
            </div>
            <h4>Subject-wise Competitions</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof2.png"
                width="62"
                height="52"
                alt="Virtual Science Fair"
              />
            </div>
            <h4>Celebration Hours</h4>
            <!-- <strong>Per Month</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof3.png"
                width="56"
                height="55"
                alt="AI-powered Project Championship"
              />
            </div>
            <h4>Assembly Presentations</h4>
            <!-- <strong>Per Month</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof4.png"
                width="70"
                height="56"
                alt="Language learning Champ"
              />
            </div>
            <h4>Virtual Morning Meetings</h4>
            <!-- <strong>Per Week</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof5.png"
                width="54"
                height="60"
                alt="Storytelling and Poetry Recitals"
              />
            </div>
            <h4>Motivational Mondays</h4>
            <!-- <strong>Per Month</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof6.png"
                width="56"
                height="50"
                alt="Cultural Festivals"
              />
            </div>
            <h4>Virtual Tours</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof7.png"
                width="62"
                height="58"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Art & Craft Ventures</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof8.png"
                width="56"
                height="58"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>AI & IT Empowered Learnings</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof9.png"
                width="42"
                height="50"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Science Projects</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof10.png"
                width="48"
                height="56"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Mindful Moments</h4>
            <!-- <strong>Per Week</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof11.png"
                width="56"
                height="56"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Book Reviews</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof12.png"
                width="58"
                height="58"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Yoga Practices</h4>
            <!-- <strong>Daily</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof13.png"
                width="56"
                height="56"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Virtual Gardening Campaigns</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof14.png"
                width="57"
                height="51"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Health Talks</h4>
            <!-- <strong>Per Month</strong> -->
          </div>

          <div class="single-actvity">
            <div class="img-div">
              <img
                src="/assets/images/os-images/listof15.png"
                width="57"
                height="56"
                alt="Virtual Gardening Campaign"
              />
            </div>
            <h4>Global Connects</h4>
            <!-- <strong>Per Annum</strong> -->
          </div>
        </div>
      </div>
    </section>

     <section class="clubsociety">
      <div class="container">
        <div class="headings">
          <h2>SOCIETIES & <span class="plannedprogram-text">CLUB</span></h2>
        </div>
        <div class="desc">
          <p>
            At KIPS Online School, our societies and clubs unlock hidden potentials and
            nurture diverse skill sets in students. Through innovative experiences, our
            students gain leadership, teamwork, confidence, and exposure. There are five
            societies and one club: Encouraging learners to explore and develop their
            personalities, creativity and skills
          </p>
        </div>

        <div class="row align-items-start gy-4 pt-2">
          <div class="col-md-6">
            <VueSlickCarousel
              ref="imgSlider"
              v-bind="imgSettings"
              @afterChange="handleAfterChange"
              class="clubImg"
            >
              <div>
                <img
                  src="/assets/images/os-images/art-design.jpeg"
                  width="759"
                  height="360"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/os-images/literar.jpeg"
                    width="759"
                  height="360"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/os-images/science-society.jpeg"
                   width="759"
                  height="360"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/os-images/biz-society.jpeg"
                  width="759"
                  height="360"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/os-images/illum.jpeg"
                   width="759"
                  height="360"
                  alt=""
                />
              </div>
              <div>
                <img
                  src="/assets/images/os-images/sports-club.jpeg"
                  width="759"
                  height="360"
                  alt=""
                />
              </div>
            </VueSlickCarousel>
          </div>
          <div class="col-md-6 col-lg-5 clubDescWrap">
            <VueSlickCarousel ref="descSlider" v-bind="descSettings" class="clubDesc">
              <div>
                <h3>ART & DESIGN SOCIETY</h3>
                <strong>Enabling Creativity</strong>
                <p>To inspire the self and whole world creatively!</p>
                <p>
                  Art & Design society brings more chances for students to express
                  artistic ideas, polish observational skills, develop creativity and
                  imagination, as well as offering them time to relax. This society
                  introduces a variety of areas to be explored in the arena of art and
                  design.
                </p>
              </div>

              <div>
                <h3>LITERARY SOCIETY</h3>
                <strong>Readers to Leaders</strong>
                <p>
                  To promote the languages and intellectual skills! Literature helps us to
                  express better.
                </p>
                <p>
                  Literary activities are source of learning new facts, teaches us about
                  history and culture, enable us to understand others’ points of view
                  making us more critical thinkers and enhance our communication skills as
                  well.
                </p>
                <p>
                  This society offers a wide range of activities for students to enhance
                  their intellect and presentation skills.
                </p>
              </div>

              <div>
                <h3>TECH SOCIETY</h3>
                <strong>Infinite Possibilities</strong>
                <p>To inspire the self and whole world creatively!</p>
                <p>
                  To expand the scientific aptitude and innovativeness The goal of science
                  is to expand knowledge and technology is the application of scientific
                  knowledge for practical purposes. The essence of how science and
                  technology contribute to society is the creation of new knowledge,
                  providing reasoning environment, hands on IT experiences, and
                  encouraging innovative ideas of young minds.
                </p>
              </div>

              <div>
                <h3>BIZ-ECON SOCIETY</h3>
                <strong>United Progress</strong>
                <p>To inspire potential future business leaders!</p>
                <p>
                  Development of any nation mainly depends on their “Economy”. Business &
                  Economics society guide our students to utilize their today’s learnings
                  with a futuristic approach. Students become friendly with business
                  related strategies, financial management, banking, entrepreneurship and
                  are also encouraged on saving habits.
                </p>
              </div>

              <div>
                <h3>ILLUME SOCIETY</h3>
                <strong>Spread the Teachings</strong>
                <p>To strengthen Islamic code of life and leadership culture</p>
                <p>
                  The purpose of this society is to enlighten the students in the view of
                  Islamic teachings and allow them to spread the words among their peers
                  and community. It is also a platform to learn and practice good habits,
                  and support each other to become lifelong leaders.
                </p>
              </div>

              <div>
                <h3>SPORTS CLUB</h3>
                <strong>Be all You can Be</strong>
                <p>To build a strong character even at hard times!</p>
                <p>
                  Learn, play & enjoy, KIPS online School’s Sports Club promotes a culture
                  of participation and togetherness.
                </p>
                <p>
                  Building a sense of healthy competition and team spirit, the
                  well-planned various sports activities help students to develop balanced
                  personalities together with physical fitness. The regularly conducted
                  intra & inter campus competitions emphasizes more on involvement than
                  outcome alone; helping every single student to play a part.
                </p>
              </div>
            </VueSlickCarousel>

           
            <div class="custom-pagination">
              <div class="numbers">
                <span
                  v-for="(num, index) in totalSlides"
                  :key="index"
                  :class="{ active: index === currentSlide }"
                  @click="goToSlide(index)"
                >
                  {{ (index + 1).toString().padStart(2, "0") }}
                </span>
              </div>
              <div class="arrow d-flex align-items-center pointer" @click="nextSlide">
                <svg
                  width="21"
                  height="12"
                  viewBox="0 0 21 12"
                  fill=""
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.765625 5.34277C0.351411 5.34277 0.015625 5.67856 0.015625 6.09277C0.015625 6.50699 0.351411 6.84277 0.765625 6.84277V5.34277ZM20.5186 6.6231C20.8115 6.33021 20.8115 5.85534 20.5186 5.56244L15.7456 0.789473C15.4527 0.496579 14.9779 0.496579 14.685 0.789473C14.3921 1.08237 14.3921 1.55724 14.685 1.85013L18.9276 6.09277L14.685 10.3354C14.3921 10.6283 14.3921 11.1032 14.685 11.3961C14.9779 11.689 15.4527 11.689 15.7456 11.3961L20.5186 6.6231ZM0.765625 6.09277V6.84277H19.9883V6.09277V5.34277H0.765625V6.09277Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> 
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      currentSlide: 0,
      totalSlides: 6, // Update if you add more slides
      imgSettings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: null,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
      },
      descSettings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: null,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.imgSettings.asNavFor = this.$refs.descSlider;
    this.descSettings.asNavFor = this.$refs.imgSlider;
  },

  methods: {
    handleAfterChange(current) {
      this.currentSlide = current;
    },
    nextSlide() {
      this.$refs.imgSlider.next();
    },
    goToSlide(index) {
      this.$refs.imgSlider.goTo(index);
    },
  },
};
</script>
